import type { PrivateGroupMembership, YammerState } from '../../state/types';

type GetPrivateGroupMembershipOfUser = (state: YammerState, membershipId: PrivateGroupMembership['id']) => boolean;
export const getPrivateGroupMembershipOfUser: GetPrivateGroupMembershipOfUser = (state, membershipId) => {
  const { fulfilled } = state.privateGroupMemberships;
  const membershipInfo = fulfilled.byId[membershipId];

  return !!membershipInfo && membershipInfo.isMember;
};

type IsPendingPrivateGroupMembershipRequest = (
  state: YammerState,
  membershipId: PrivateGroupMembership['id']
) => boolean;
export const isPendingPrivateGroupMembershipRequest: IsPendingPrivateGroupMembershipRequest = (state, membershipId) =>
  !!Object.prototype.hasOwnProperty.call(state.privateGroupMemberships.pending.byId, membershipId);
